import styled from 'styled-components';

const GroupHeading = styled.h3(({ theme: { fontSizes }, theme }) => ({
  fontSize: fontSizes[4],
  ...theme.text.groupHeading,
}));

export default GroupHeading;
